export default "__VITE_ASSET__BMtUwrXh__"